import React from 'react';
import { useReservations } from '../ReservationContext';

const TablesView = ({ onOpenCreate, onOpenEdit }) => {
  const {
    tables,
    tableStats,
    zones,
    deleteTable,
    loading,
  } = useReservations();

  const handleDelete = async (table) => {
    if (window.confirm(`Are you sure you want to remove table ${table.table_id}?`)) {
      await deleteTable(table);
    }
  };

  return (
    <div className="tables-view">
      <div className="tables-toolbar">
        <div className="toolbar-left">
          <h3>Table Inventory</h3>
        </div>
        <div className="toolbar-right">
          <button className="btn btn-primary" onClick={onOpenCreate}>
            + Add Table
          </button>
        </div>
      </div>

      {tableStats && (
        <div className="stats-row">
          <div className="stat-card">
            <div className="stat-value">{tableStats.total_tables}</div>
            <div className="stat-label">Total Tables</div>
          </div>
          <div className="stat-card">
            <div className="stat-value">{tableStats.total_capacity}</div>
            <div className="stat-label">Total Capacity</div>
          </div>
          {tableStats.by_type && Object.entries(tableStats.by_type).map(([type, data]) => (
            <div className="stat-card" key={type}>
              <div className="stat-value">{data.count}</div>
              <div className="stat-label">{type}s</div>
            </div>
          ))}
        </div>
      )}

      <div className="tables-grid">
        {tables.map((table) => (
          <div
            key={table.table_id}
            className={`table-card ${table.is_active ? '' : 'table-inactive'}`}
          >
            <div className="table-header">
              <span className="table-id">{table.table_id}</span>
              <span className={`table-status status-${table.status}`}>
                {table.status}
              </span>
            </div>
            <div className="table-body">
              <div className="table-name">{table.table_name}</div>
              <div className="table-info">
                <span className="table-type">{table.table_type}</span>
                <span className="table-capacity">{table.capacity} seats</span>
              </div>
              <div className="table-zone">
                {table.zone_id ? (
                  zones.find(z => z.zone_id === table.zone_id)?.zone_name || table.zone_id
                ) : (
                  <span className="no-zone">No zone assigned</span>
                )}
              </div>
            </div>
            <div className="table-actions">
              <button
                className="action-btn edit-btn"
                onClick={() => onOpenEdit(table)}
              >
                Edit
              </button>
              <button
                className="action-btn delete-btn"
                onClick={() => handleDelete(table)}
                disabled={loading}
              >
                Remove
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TablesView;
